import { useContext, useState, useEffect, useCallback } from 'react';
import { Switch } from '@ascd/witsby-components';
import { Box } from '@mui/material';
import { DashboardContext, eDashboardActionType } from '@contexts/dashboardContext';
import { DASHBOARD_ASSIGNED_BY } from '@utils';

const AdminDashboardSidebarAssignedOrSelfAssigned = () => {
  const {
    dispatch,
    state: { sideBarFilter },
  } = useContext(DashboardContext);

  const { assignedBy } = sideBarFilter;

  const [switchStates, setSwitchStates] = useState<boolean[]>(() =>
    DASHBOARD_ASSIGNED_BY.map((type) => assignedBy.includes(type._id)),
  );
  const updateSwitchStates = useCallback(() => {
    setSwitchStates(DASHBOARD_ASSIGNED_BY.map((type) => assignedBy.includes(type._id)));
  }, [assignedBy]);

  useEffect(() => {
    updateSwitchStates();
  }, [assignedBy, updateSwitchStates]);

  const getAssignByPayload = (value: boolean, type: { _id: string; name: string }) => {
    if (value) {
      return [...assignedBy, type._id];
    }
    if (switchStates.filter((e) => e).length === 1 && !value) {
      return DASHBOARD_ASSIGNED_BY.filter((assigned) => assigned._id !== type._id).map(
        (e) => e._id,
      );
    }
    return assignedBy.filter((assigned: string) => assigned !== type._id);
  };
  return (
    <Box
      className="assign-by"
      sx={(theme) => ({
        p: 2,
        border: '1px solid',
        borderColor: theme.palette.grey[500],
        borderRadius: theme.border.radius.REGULAR,
      })}>
      {DASHBOARD_ASSIGNED_BY.map((type, index) => (
        <Box
          key={type._id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            '&:first-child': {
              mb: 1,
            },
          }}>
          <Switch
            inputProps={{ 'aria-label': type.name }}
            checked={switchStates[`${index}`]}
            onChange={(_, value) => {
              const newSwitchStates = [...switchStates];
              // This is for check at least one switch will be on
              if (newSwitchStates.filter((e) => e).length === 1 && !value) {
                setSwitchStates(
                  (newSwitchStates || []).map((v, i) => (i !== index ? true : value)),
                );
              } else {
                newSwitchStates[`${index}`] = value;
                setSwitchStates(newSwitchStates);
              }

              dispatch({
                type: 'SIDEBAR_FILTER' as eDashboardActionType.SIDEBAR_FILTER,
                data: {
                  ...sideBarFilter,
                  assignedBy: getAssignByPayload(value, type),
                },
              });
            }}
          />
          <Box
            sx={(theme) => ({
              ml: 0.5,
              fontSize: theme.font.size.SMALL,
            })}>
            {type.name}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AdminDashboardSidebarAssignedOrSelfAssigned;
